import { getAppLang, getProperty, getUserToken } from "../../../../utils";
import axios from "axios";
import {
    WEB_META_GET,
    WEB_META_TAG_GET,
    WEB_META_TAG_SYNC,
    WEB_META_TAG_MAPPING_GET
} from "../../../../constants/api.constants";
import { metaTagConstants } from "../../../../constants/Web/metaTag.constants";

const headers = () => ({
    'Content-Type': 'application/json',
    'authToken': getUserToken(),
    'language': getAppLang()
});

export function getMetaList() {
    const body = {
        params: {
            property_id: getProperty(),
        }
    };

    return dispatch => {
        dispatch({
            type: 'META_LIST',
            payload: axios.post(WEB_META_GET, body, { headers: headers() })
                .then(response => response.data.data)
        });
    };
}

export function getMetaTagList() {
    const body = {
        params: {
            property_id: getProperty(),
        }
    };

    return dispatch => {
        dispatch({
            type: 'META_TAG_LIST',
            payload: axios.post(WEB_META_TAG_GET, body, { headers: headers() })
                .then(response => response.data.data)
        });
    };
}

export function getMetaTagMapping(filter = {}) {
    const body = {
        params: {
            property_id: getProperty(),
            ...(Object.keys(filter).length > 0 && { filter })
        }
    };

    return dispatch => {
        dispatch({
            type: 'META_TAG_MAPPING',
            payload: axios.post(WEB_META_TAG_MAPPING_GET, body, { headers: headers() })
                .then(response => response.data.data)
        });
    };
}

export function syncMetaTag(params) {
    const body = {
        params: {
            property_id: getProperty(),
            property_web_id: params.property_web_id,
            property_web_meta_id: params.property_web_meta_id,
            property_web_meta_tag_id: params.property_web_meta_tag_id,
            code: params.code || null,
            text: params.text,
        }
    };

    return dispatch => {
        dispatch({
            type: 'META_TAG_SYNC',
            payload: axios.post(WEB_META_TAG_SYNC, body, { headers: headers() })
                .then(response => response.data.data)
        });
    };
}

export function clearMetaTagSync() {
    return dispatch => {
        dispatch({
            type: metaTagConstants.META_TAG_SYNC_CLEAR,
        });
    };
}
